export const RESIZE_MIN_WIDTH = '25px';
export const RESIZE_MAX_WIDTH = '100%';
